import { useState } from 'react'
import { DonorMascot } from '../DonorMascot'
import type { MascotConfig } from '../mascot-catalog'
import styles from './MascotVeterinary.module.css'

export function VeterinaryScene({
  mascot,
  health,
  completed,
}: {
  mascot: MascotConfig
  health: number
  completed: boolean
}) {
  const [petted, setPetted] = useState(false)
  return (
    <div className={styles.scene} data-completed={completed}>
      <svg
        viewBox="0 0 640 320"
        className={styles.drawing}
        role="img"
        aria-label="Veterinário ao lado da mesa de consulta"
      >
        <rect width="640" height="320" rx="24" fill="#e6f1e8" />
        <path d="M0 258H640V320H0Z" fill="#e4d7bd" />
        <path d="M0 258H640M32 289H606" stroke="#cbbd9f" strokeWidth="3" />
        <rect
          x="32"
          y="32"
          width="88"
          height="105"
          rx="38"
          fill="#fffdf4"
          stroke="#bccfbf"
          strokeWidth="5"
        />
        <path d="M44 91q28-27 63 0v32H44Z" fill="#b4d6b6" />
        <circle cx="93" cy="62" r="13" fill="#f3cc72" />
        <path d="M76 34v101M33 85h85" stroke="#fffdf4" strokeWidth="5" />
        <rect
          x="514"
          y="73"
          width="93"
          height="139"
          rx="13"
          fill="#fffdf4"
          stroke="#a3bdaa"
          strokeWidth="4"
        />
        <path d="M515 145h91M560 146v64" stroke="#a3bdaa" strokeWidth="3" />
        <circle cx="550" cy="165" r="3" fill="#698b74" />
        <circle cx="571" cy="165" r="3" fill="#698b74" />
        <rect x="534" y="102" width="22" height="29" rx="5" fill="#a8cdb1" />
        <path d="M538 96h14" stroke="#668a73" strokeWidth="5" strokeLinecap="round" />
        <rect x="570" y="105" width="18" height="26" rx="5" fill="#f0c98b" />
        <path d="M574 100h10" stroke="#b99567" strokeWidth="5" strokeLinecap="round" />
        <path
          d="M42 253v-47m0 21q-28-4-20-28 26 0 20 28m0-12q27-8 22-29-26 1-22 29"
          fill="#79a789"
          stroke="#618870"
          strokeWidth="3"
        />
        <path d="M23 243h38l-7 32H30Z" fill="#cb8e70" />
        <ellipse cx="185" cy="291" rx="65" ry="10" fill="#b3a789" opacity=".4" />
        <path d="m153 222-7 61h29l13-61m6 0 8 61h28l-12-61" fill="#65877b" />
        <path d="M145 280h31v12h-40q-3-10 9-12m57 0h28q14 2 13 12h-41Z" fill="#395a51" />
        <path
          d="M149 144q34-18 64 0l14 89q-39 14-83 0Z"
          fill="#fffdf5"
          stroke="#8eab99"
          strokeWidth="3"
        />
        <path
          d="m150 147-31 59q-2 13 12 15l28-42m52-29 47 39 39-9"
          fill="none"
          stroke="#fffdf5"
          strokeWidth="24"
          strokeLinecap="round"
        />
        <path
          d="m122 214 4 12m169-46 13-2"
          stroke="#c79677"
          strokeWidth="13"
          strokeLinecap="round"
        />
        <rect x="171" y="129" width="27" height="24" rx="10" fill="#c79677" />
        <ellipse cx="183" cy="104" rx="35" ry="38" fill="#dbad8c" />
        <path
          d="M148 107q-17-51 24-49 35-18 51 26l-10 17q-5-15-13-24-17 14-41 10l-6 22Z"
          fill="#705044"
        />
        <circle cx="171" cy="103" r="3" fill="#493e36" />
        <circle cx="196" cy="103" r="3" fill="#493e36" />
        <path
          d="M175 119q10 8 18-1"
          fill="none"
          stroke="#8e5d4d"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="m162 146 16 21 7-14 8 14 15-21M185 162v66"
          fill="none"
          stroke="#b5cbb9"
          strokeWidth="3"
        />
        <path
          d="M164 149v29q0 16 14 16t14-16v-28m-14 44v16"
          fill="none"
          stroke="#4f7866"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <circle cx="178" cy="210" r="7" fill="#89bba0" stroke="#4f7866" strokeWidth="3" />
        <rect x="204" y="170" width="13" height="15" rx="3" fill="#e8b2a0" />
        <path d="M210 173v9m-4-4h8" stroke="#fffdf5" strokeWidth="2" />
        <path
          d="M344 237v53m172-53v53"
          stroke="#6a8b7a"
          strokeWidth="12"
          strokeLinecap="round"
        />
        <path d="M344 269h172" stroke="#94ad98" strokeWidth="7" />
        <rect
          x="320"
          y="225"
          width="220"
          height="18"
          rx="9"
          fill="#83b8a0"
          stroke="#577e6a"
          strokeWidth="3"
        />
        <rect x="328" y="221" width="204" height="8" rx="4" fill="#fff8e4" />
        <g className={styles.sparkle} fill="#dba85b">
          <path d="m478 176 4 9 10 4-10 4-4 9-4-9-10-4 10-4Z" />
          <path d="m338 117 3 7 7 3-7 3-3 7-3-7-7-3 7-3Z" />
        </g>
      </svg>
      <p className={styles.speech} aria-live="polite">
        {completed
          ? 'Consulta concluída! Obrigado pelo apoio. ♡'
          : petted
            ? 'Carinho recebido! ♡'
            : mascot.name.length > 18
              ? 'Vamos cuidar de você?'
              : `Vamos cuidar de ${mascot.name}?`}
      </p>
      <button
        type="button"
        className={styles.patient}
        aria-label={`Fazer carinho em ${mascot.name}`}
        onClick={() => setPetted((value) => !value)}
      >
        <DonorMascot
          config={mascot}
          showBackdrop={false}
          needs={{ health }}
          expression={petted || completed ? 'tickled' : 'happy'}
          label={`${mascot.name} na mesa de consulta`}
        />
      </button>
      <span className={styles.sceneHint}>Toque no pet para fazer carinho</span>
    </div>
  )
}
